import React from "react";
import { Link } from "@mui/material";
import LearnHowIcon from "../../../assets/images/icons/learn_how_icon.png";
import { useTranslation } from "../../../context/Internationalization";
import { useConsoleHelpLinks } from "../../../context/ConsoleHelpLinksContext";
import { getConsoleHelpUrl } from "../../../utility/consoleHelpLinks";
import { fonts } from "../../../theme/fonts";

export default function PageHelp({ pageKey }) {
  const { lang, t } = useTranslation();
  const help = useConsoleHelpLinks();
  const url = getConsoleHelpUrl(help?.configuration, pageKey, lang);
  if (!url) return null;
  return <Link href={url} target="_blank" rel="noopener noreferrer" underline="hover"
    sx={{ display: "inline-flex", alignItems: "center", gap: 1, mt: 0.5, ...fonts.text.sm.normal }}>
    <img src={LearnHowIcon} alt="" style={{ width: 17, height: 14 }} />
    {t("page_help_need_help")}
  </Link>;
}
